<template>
  <div>
    <BreadCrumb class="bread" :breads="['商品管理', '商品列表']"></BreadCrumb>
    <div class="wrap">
      <div class="header">
        <span class="nameFt">商品列表</span>
      </div>
    </div>
    <div class="submit-form">
      <el-form :model="search" :inline="true" size="small" label-width="80px">
        <div class="submit-form__search">
          <el-form-item label="商品名称">
            <el-input v-model="search.items_name" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="分类名称">
            <el-input
              v-model="search.category_name"
              suffix-icon="el-icon-search"
              @focus="openCategoryDialog"
              readonly="readonly"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品编号">
            <el-input v-model="search.number"></el-input>
          </el-form-item>
          <!-- <el-form-item label="训练状态">
            <el-select v-model="search.status">
              <el-option :value="true" label="是"></el-option>
              <el-option :value="false" label="否"></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="商城使用">
            <el-select v-model="search.status">
              <el-option value="NORMAL" label="是"></el-option>
              <el-option value="DISABLE" label="否"></el-option>
            </el-select>
          </el-form-item> -->
        </div>
        <div class="submit-form__operate">
          <el-form-item>
            <el-button
              class="queryBtn"
              size="small"
              type="primary"
              @click="searchForm"
              >查询</el-button
            >
            <el-button
              class="queryBtn"
              size="small"
              type="primary"
              @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div
      class="operate-con"
      v-show="$store.getters.authority({ name: 'shopManage', type: 'add' })"
    >
      <el-button size="small" @click="openAdd">新增</el-button>
    </div>
    <div class="table-con">
      <el-table
        :data="tableList"
        stripe
        v-loading="loading"
        @sort-change="changeTableSort"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
          :index="indexMethod"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <div slot-scope="scope">
            <img :src="scope.row.image_url" width="40px" height="40px" />
          </div>
        </el-table-column>
        <el-table-column
          label="商品编号"
          align="center"
          prop="number"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          label="商品名称"
          align="center"
          prop="name"
        ></el-table-column>
        <el-table-column
          label="分类"
          align="center"
          prop="category_name"
        ></el-table-column>
        <el-table-column
          label="重量(克)"
          align="center"
          prop="weight"
          sortable="custom"
        >
          <span slot-scope="scope"
            >{{ scope.row.min_weight }} ~ {{ scope.row.max_weight }}</span
          >
        </el-table-column>
        <el-table-column
          label="成本价格"
          align="center"
          prop="cost_price"
        ></el-table-column>
        <el-table-column
          label="出售价格"
          align="center"
          prop="real_price"
        ></el-table-column>
        <!-- <el-table-column label="商城使用" align="center" prop="is_sale"></el-table-column> -->
        <el-table-column label="操作" align="center" width="250px">
          <div slot-scope="scope">
            <el-button size="small" @click="openView(scope.row.id)"
              >查看</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="openUpdate(scope.row.id)"
              v-show="
                $store.getters.authority({ name: 'shopManage', type: 'update' })
              "
              >修改</el-button
            >
            <el-button
              type="danger"
              size="small"
              @click="deleteItem(scope.row.id)"
              v-show="
                $store.getters.authority({ name: 'shopManage', type: 'delete' })
              "
              >删除</el-button
            >
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div class="paginationWrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pageSize"
        :current-page="pageNum"
        :layout="pageLayout"
        :total="total"
      >
      </el-pagination>
    </div>
    <category-dialog
      :show="categoryVisible"
      @close="closeCategoryDialog"
    ></category-dialog>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import CategoryDialog from "@/components/CategoryDialog";
import apis from "@/config/apis";
import alert from "@/plugins/alert";
import listMixin from "@/mixins/shoplist";
export default {
  mixins: [listMixin],
  data() {
    return {
      search: {},
      categoryVisible: false,
      dialogData: {},
    };
  },
  components: {
    BreadCrumb,
    CategoryDialog,
  },
  created() {
    this.search = Object.assign(this.search, this.$route.query);
    this.getData();
  },
  methods: {
    openCategoryDialog() {
      this.categoryVisible = true;
    },
    closeCategoryDialog(data) {
      if (data) {
        this.search.category_id = data.id;
        this.search.category_name = data.label;
      }
      this.categoryVisible = false;
    },
    searchForm() {
      this.search.page_index = 1;
      this.getData();
    },
    reset() {
      this.search = {};
      this.search.page_index = 1;
      this.getData();
    },
    getData() {
      this.getTableData(apis.items_list, "get", this.search, "items_list");
    },
    openView(id) {
      this.$router.push({
        name: "shoppingManageUpdate",
        query: {
          id: id,
          operate: "look",
        },
        params: this.$route.query,
      });
    },
    openAdd() {
      this.$router.push({
        name: "shoppingManageUpdate",
      });
    },
    openUpdate(id) {
      this.$router.push({
        name: "shoppingManageUpdate",
        query: {
          id: id,
          operate: "update",
        },
        params: this.$route.query,
      });
    },
    deleteItem(id) {
      alert.deleteAlert().then((res) => {
        this.$axios.delete(apis.items_list + "/" + id).then((res) => {
          if (res.data.code === 200) {
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
      });
    },
    changeTableSort(column) {
      if (column.prop === "number" && column.order === "ascending") {
        this.search.order_number = "s3";
      } else if (column.prop === "number" && column.order === "descending") {
        this.search.order_number = "s4";
      }
      if (column.prop === "weight" && column.order === "ascending") {
        this.search.order_weight = "s1";
      } else if (
        column.prop === "weight" &&
        column.order === "descending"
      ) {
        this.search.order_weight = "s2";
      }
      if (!column.prop) {
        this.search.order_number = "";
        this.search.order_weight = "";
      }
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
